(function () {
  'use strict';

  if (window.KKProductVariantController) {
    return;
  }

  var COLOR_OPTION_NAMES = ['v\u00e4ri', 'vari', 'color', 'colour', 'f\u00e4rg', 'farg'];
  var WEIGHT_OPTION_NAMES = ['paino', 'weight', 'vikt'];
  var PRODUCT_OPTION_SELECTOR = '[data-product-options-container]';
  var LOWEST_PRICE_SELECTOR = '[data-lowest-30d-price]';
  var BACK_IN_STOCK_SELECTOR = '[data-kk-back-in-stock]';
  var sectionDataCache = Object.create(null);
  var containerStates = new WeakMap();
  var deferredOptionData = new WeakMap();
  var initializedBackInStockRoots = new WeakSet();
  var updateFrame = null;
  var photoswipeReturnFocusTarget = null;
  var photoswipeReturnFigureTarget = null;
  var photoswipeReturnSectionId = '';
  var photoswipeWasOpen = false;

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function parseJson(element, fallback) {
    if (!element) {
      return fallback;
    }

    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function getSectionDataElement(sectionId) {
    var elements = document.querySelectorAll('[data-section-data][data-section-id]');

    for (var index = 0; index < elements.length; index++) {
      if (elements[index].getAttribute('data-section-id') === sectionId) {
        return elements[index];
      }
    }

    return null;
  }

  function getSectionData(sectionId) {
    if (!sectionId) {
      return null;
    }

    var element = getSectionDataElement(sectionId);
    var cached = sectionDataCache[sectionId];

    if (cached && cached.element === element) {
      return cached.data;
    }

    var data = parseJson(element, null);
    sectionDataCache[sectionId] = {
      element: element,
      data: data
    };

    return data;
  }

  function getSectionId(element) {
    if (!element) {
      return '';
    }

    return element.getAttribute('data-product-section-id') ||
      element.getAttribute('data-section-id') ||
      '';
  }

  function getProductData(element) {
    var sectionData = getSectionData(getSectionId(element));
    return sectionData && sectionData.product ? sectionData.product : null;
  }

  function getContainerState(container) {
    var state = containerStates.get(container);

    if (!state) {
      state = { dynamicSelections: Object.create(null) };
      containerStates.set(container, state);
    }

    return state;
  }

  function getProductRoot(element) {
    return element.closest('[data-product-wrapper]') ||
      element.closest('[data-product-quickshop]') ||
      element.closest('.product--outer') ||
      document;
  }

  function getUrlVariantId() {
    if (!window.URLSearchParams) {
      return null;
    }

    return new URLSearchParams(window.location.search).get('variant');
  }

  function getCurrentVariantId(element, preferUrl) {
    var productRoot = getProductRoot(element);
    var urlVariantId = getUrlVariantId();

    if (preferUrl && urlVariantId && productRoot !== document) {
      return urlVariantId;
    }

    var form = productRoot.querySelector(
      'form[data-product-form], form[action*="/cart/add"], [data-product-form] form'
    );
    var idField = form && form.querySelector('[name="id"]');

    if (idField && idField.value) {
      return idField.value;
    }

    var variantsField = productRoot.querySelector('[data-variants], [name="id"]');

    if (variantsField && variantsField.value) {
      return variantsField.value;
    }

    return urlVariantId || element.getAttribute('data-initial-variant-id');
  }

  function findVariant(product, variantOrId) {
    if (!product || !product.variants) {
      return null;
    }

    var id = variantOrId && typeof variantOrId === 'object'
      ? variantOrId.id
      : variantOrId;

    if (!id) {
      return null;
    }

    for (var index = 0; index < product.variants.length; index++) {
      if (String(product.variants[index].id) === String(id)) {
        return product.variants[index];
      }
    }

    return null;
  }

  function getCurrentVariant(element, product, preferUrl) {
    return findVariant(product, getCurrentVariantId(element, preferUrl));
  }

  function getDeferredValues(fieldset) {
    if (deferredOptionData.has(fieldset)) {
      return deferredOptionData.get(fieldset);
    }

    var values = parseJson(fieldset.querySelector('[data-variant-load-more-data]'), []);
    var list = fieldset.querySelector('[data-variant-load-more-list]');
    var existingValues = Object.create(null);

    if (list) {
      toArray(list.querySelectorAll('input[data-product-option]:not([data-variant-option-proxy])')).forEach(function (input) {
        existingValues[input.value] = true;
      });
    }

    values = Array.isArray(values) ? values.filter(function (value) {
      return value && !existingValues[value.value];
    }) : [];

    deferredOptionData.set(fieldset, values);
    return values;
  }

  function insertOptionWrapper(list, wrapper, position) {
    var wrappers = list.querySelectorAll('[data-option-value-wrapper][data-variant-option-position]');
    var reference = list.querySelector('[data-variant-option-proxy]');

    for (var index = 0; index < wrappers.length; index++) {
      if (parseInt(wrappers[index].getAttribute('data-variant-option-position'), 10) > position) {
        reference = wrappers[index];
        break;
      }
    }

    list.insertBefore(wrapper, reference || null);

    // Liquid-rendered option wrappers are separated by collapsible whitespace.
    // Preserve that same inline-block gap for dynamically inserted wrappers so
    // responsive rows keep the exact same capacity before and after loading.
    list.insertBefore(document.createTextNode('\n'), reference || null);
  }

  function createOptionControl(list, optionData) {
    var optionIndex = list.getAttribute('data-variant-option-index');
    var inputId = list.getAttribute('data-variant-option-id-prefix') + optionData.position;
    var showSwatches = list.getAttribute('data-variant-option-swatches') === 'true';
    var wrapper = document.createElement('div');
    var label = document.createElement('label');
    var input = document.createElement('input');
    var name = document.createElement('span');

    wrapper.className = 'option-value';
    wrapper.setAttribute('data-option-value-wrapper', '');
    wrapper.setAttribute('data-variant-option-position', optionData.position);

    label.className = 'option-value-label';
    label.htmlFor = inputId;

    input.className = 'option-value-input';
    input.type = 'radio';
    input.name = list.getAttribute('data-variant-option-name');
    input.value = optionData.value;
    input.setAttribute('aria-label', optionData.value);
    input.setAttribute('data-product-option', optionIndex);
    input.setAttribute('data-variant-option-dynamic', '');
    input.setAttribute('data-soldout', 'false');
    input.id = inputId;

    name.className = 'option-value-name' + (showSwatches ? ' option-value-swatch-wrapper' : '');
    name.tabIndex = -1;

    if (showSwatches) {
      var swatch = document.createElement('div');
      var swatchInner = document.createElement('div');

      name.setAttribute('data-swatch-tooltip', optionData.value);
      swatch.className = 'swatch';
      swatch.style.cssText = optionData.swatchOuterStyle || '';
      swatchInner.className = 'swatch-inner';
      swatchInner.style.cssText = optionData.swatchInnerStyle || '';
      swatch.appendChild(swatchInner);
      name.appendChild(swatch);
    } else {
      name.textContent = optionData.value;
    }

    label.appendChild(input);
    label.appendChild(name);
    wrapper.appendChild(label);
    insertOptionWrapper(list, wrapper, Number(optionData.position));

    return input;
  }

  function getOptionStatus(product, currentVariant, optionIndex, optionValue) {
    var exists = false;
    var available = false;

    if (!product || !currentVariant || !product.variants) {
      return { exists: true, available: true };
    }

    product.variants.forEach(function (candidate) {
      var firstDifference = -1;

      for (var index = 0; index < candidate.options.length; index++) {
        if (candidate.options[index] !== currentVariant.options[index]) {
          firstDifference = index;
          break;
        }
      }

      if (
        (candidate.id === currentVariant.id || firstDifference === optionIndex) &&
        candidate.options[optionIndex] === optionValue
      ) {
        exists = true;
        available = available || Boolean(candidate.available);
      }
    });

    return { exists: exists, available: available };
  }

  function syncOptionControls(container, variant, product) {
    if (!container || !variant || !variant.options) {
      return;
    }

    var state = getContainerState(container);

    toArray(container.querySelectorAll('[data-variant-option-index]')).forEach(function (list) {
      var optionIndex = parseInt(list.getAttribute('data-variant-option-index'), 10);
      var selectedValue = variant.options[optionIndex];
      var selectedDynamicInput = null;

      toArray(list.querySelectorAll('input[data-product-option]:not([data-variant-option-proxy])')).forEach(function (input) {
        var selected = input.value === selectedValue;
        var wrapper = input.closest('[data-option-value-wrapper]');

        input.checked = selected;

        if (input.hasAttribute('data-variant-option-dynamic')) {
          var status = getOptionStatus(product, variant, optionIndex, input.value);

          // This theme deliberately keeps sold-out option values selectable so
          // the customer can open the back-in-stock flow. Only impossible
          // combinations stay disabled.
          input.disabled = !status.exists;
          input.setAttribute('data-soldout', status.exists && !status.available ? 'true' : 'false');

          if (selected) {
            selectedDynamicInput = input;
          }
        }

        if (wrapper) {
          wrapper.classList.toggle('option-selected', selected);
        }
      });

      if (selectedDynamicInput) {
        state.dynamicSelections[optionIndex] = selectedValue;
        selectedDynamicInput.checked = true;
      } else {
        delete state.dynamicSelections[optionIndex];
      }

      var swatchValue = container.querySelector('[data-option-swatch-value="' + optionIndex + '"]');

      if (swatchValue) {
        swatchValue.textContent = selectedValue;
      }
    });
  }

  function prepareDynamicProxies(container) {
    var state = getContainerState(container);

    Object.keys(state.dynamicSelections).forEach(function (optionIndex) {
      var proxy = container.querySelector('[data-variant-option-proxy="' + optionIndex + '"]');

      if (!proxy) {
        return;
      }

      proxy.value = state.dynamicSelections[optionIndex];
      proxy.disabled = false;
      proxy.checked = true;
    });
  }

  function handleDynamicOptionChange(input, container) {
    var optionIndex = input.getAttribute('data-product-option');
    var state = getContainerState(container);
    var proxy = container.querySelector('[data-variant-option-proxy="' + optionIndex + '"]');
    var restoreFocus = document.activeElement === input;

    state.dynamicSelections[optionIndex] = input.value;
    prepareDynamicProxies(container);

    if (!proxy) {
      return;
    }

    proxy.value = input.value;
    proxy.disabled = false;
    proxy.checked = true;
    proxy.dispatchEvent(new Event('change', { bubbles: true }));

    if (restoreFocus) {
      window.requestAnimationFrame(function () {
        if (!document.documentElement.contains(input)) {
          return;
        }

        try {
          input.focus({ preventScroll: true });
        } catch (error) {
          input.focus();
        }
      });
    }
  }

  function handleOptionChangeCapture(event) {
    var input = event.target;

    if (
      !input ||
      input.nodeType !== 1 ||
      !input.matches('[data-product-option]') ||
      input.hasAttribute('data-variant-option-proxy')
    ) {
      return;
    }

    var container = input.closest(PRODUCT_OPTION_SELECTOR);

    if (!container) {
      return;
    }

    var state = getContainerState(container);
    var optionIndex = input.getAttribute('data-product-option');

    if (input.hasAttribute('data-variant-option-dynamic')) {
      handleDynamicOptionChange(input, container);
      return;
    }

    delete state.dynamicSelections[optionIndex];
    prepareDynamicProxies(container);
  }

  function expandOptionList(button) {
    var fieldset = button.closest('fieldset');
    var list = fieldset && fieldset.querySelector('[data-variant-load-more-list]');

    if (!fieldset || !list) {
      return;
    }

    var values = getDeferredValues(fieldset);
    var step = parseInt(button.getAttribute('data-variant-load-more-step'), 10) || 40;
    var productContainer = fieldset.closest(PRODUCT_OPTION_SELECTOR);
    var product = productContainer && getProductData(productContainer);
    var currentVariant = productContainer && getCurrentVariant(productContainer, product, false);

    values.splice(0, step).forEach(function (optionData) {
      createOptionControl(list, optionData);
    });

    if (!values.length) {
      button.hidden = true;
    }

    if (productContainer && currentVariant) {
      syncOptionControls(productContainer, currentVariant, product);
      updateUniikkiContainer(productContainer);
    }

    fieldset.dispatchEvent(new CustomEvent('kk:product-options:expanded', {
      bubbles: true,
      detail: { remaining: values.length }
    }));
  }

  function normalizeOptionName(name) {
    return String(name || '').trim().toLocaleLowerCase();
  }

  function getOptionIndex(product, optionNames) {
    if (!product || !product.options) {
      return -1;
    }

    for (var index = 0; index < product.options.length; index++) {
      if (optionNames.indexOf(normalizeOptionName(product.options[index])) !== -1) {
        return index;
      }
    }

    return -1;
  }

  function getSelectedOptions(container, product) {
    var selectedOptions = product && product.options ? product.options.map(function () {
      return null;
    }) : [];

    toArray(container.querySelectorAll('select[data-product-option]')).forEach(function (select) {
      selectedOptions[parseInt(select.getAttribute('data-product-option'), 10)] = select.value;
    });

    toArray(container.querySelectorAll('input[type="radio"][data-product-option]:checked')).forEach(function (input) {
      selectedOptions[parseInt(input.getAttribute('data-product-option'), 10)] = input.value;
    });

    return selectedOptions;
  }

  function getMatchingVariants(product, selectedOptions, colorIndex, weightIndex, optionIndex, optionValue, requireOtherOptions) {
    return product.variants.filter(function (variant) {
      if (!variant.options || variant.options[optionIndex] !== optionValue) {
        return false;
      }

      if (optionIndex === weightIndex && variant.options[colorIndex] !== selectedOptions[colorIndex]) {
        return false;
      }

      if (!requireOtherOptions) {
        return true;
      }

      for (var index = 0; index < selectedOptions.length; index++) {
        if (index === colorIndex || index === weightIndex || selectedOptions[index] == null) {
          continue;
        }

        if (variant.options[index] !== selectedOptions[index]) {
          return false;
        }
      }

      return true;
    });
  }

  function isOptionAvailable(product, selectedOptions, colorIndex, weightIndex, optionIndex, optionValue) {
    var matchingVariants = getMatchingVariants(
      product,
      selectedOptions,
      colorIndex,
      weightIndex,
      optionIndex,
      optionValue,
      true
    );

    if (!matchingVariants.length) {
      matchingVariants = getMatchingVariants(
        product,
        selectedOptions,
        colorIndex,
        weightIndex,
        optionIndex,
        optionValue,
        false
      );
    }

    return matchingVariants.some(function (variant) {
      return variant.available;
    });
  }

  function isRadioVisible(input, attributeName) {
    var wrapper = input.closest('[data-option-value-wrapper]');
    return wrapper && wrapper.getAttribute(attributeName) !== 'true' && !wrapper.hasAttribute('hidden');
  }

  function updateSelectOptions(select, product, selectedOptions, colorIndex, weightIndex, optionIndex, attributeName) {
    var selectedOption = select.options[select.selectedIndex];
    var selectedOptionHidden = false;
    var firstVisibleOption = null;

    toArray(select.options).forEach(function (option) {
      var shouldHide = !isOptionAvailable(
        product,
        selectedOptions,
        colorIndex,
        weightIndex,
        optionIndex,
        option.value
      );

      option.hidden = shouldHide;
      option.disabled = shouldHide;
      option.setAttribute(attributeName, shouldHide ? 'true' : 'false');

      if (!shouldHide && !firstVisibleOption) {
        firstVisibleOption = option;
      }

      if (option === selectedOption && shouldHide) {
        selectedOptionHidden = true;
      }
    });

    if (selectedOptionHidden && firstVisibleOption) {
      select.value = firstVisibleOption.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function updateRadioOptions(container, product, selectedOptions, colorIndex, weightIndex, optionIndex, attributeName) {
    var inputs = toArray(container.querySelectorAll(
      'input[type="radio"][data-product-option="' + optionIndex + '"]:not([data-variant-option-proxy])'
    ));
    var checkedInputHidden = false;
    var firstVisibleInput = null;

    inputs.forEach(function (input) {
      var wrapper = input.closest('[data-option-value-wrapper]');
      var shouldHide = !isOptionAvailable(
        product,
        selectedOptions,
        colorIndex,
        weightIndex,
        optionIndex,
        input.value
      );

      input.setAttribute(attributeName, shouldHide ? 'true' : 'false');

      if (wrapper) {
        wrapper.setAttribute(attributeName, shouldHide ? 'true' : 'false');
        wrapper.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      }

      if (!shouldHide && !firstVisibleInput && isRadioVisible(input, attributeName)) {
        firstVisibleInput = input;
      }

      if (input.checked && shouldHide) {
        checkedInputHidden = true;
      }
    });

    if (checkedInputHidden && firstVisibleInput) {
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function updateUniikkiContainer(container) {
    if (container.getAttribute('data-kk-weight-filter') !== 'true') {
      return;
    }

    var product = getProductData(container);
    var colorIndex = getOptionIndex(product, COLOR_OPTION_NAMES);
    var weightIndex = getOptionIndex(product, WEIGHT_OPTION_NAMES);

    if (!product || colorIndex === -1 || weightIndex === -1 || colorIndex === weightIndex) {
      return;
    }

    var selectedOptions = getSelectedOptions(container, product);
    var changedColor = false;

    if (container.getAttribute('data-kk-color-filter') === 'true') {
      toArray(container.querySelectorAll('select[data-product-option="' + colorIndex + '"]')).forEach(function (select) {
        changedColor = updateSelectOptions(
          select,
          product,
          selectedOptions,
          colorIndex,
          weightIndex,
          colorIndex,
          'data-kk-uniikki-color-hidden'
        ) || changedColor;
      });

      changedColor = updateRadioOptions(
        container,
        product,
        selectedOptions,
        colorIndex,
        weightIndex,
        colorIndex,
        'data-kk-uniikki-color-hidden'
      ) || changedColor;
    }

    if (changedColor) {
      return;
    }

    selectedOptions = getSelectedOptions(container, product);

    if (!selectedOptions[colorIndex]) {
      return;
    }

    toArray(container.querySelectorAll('select[data-product-option="' + weightIndex + '"]')).forEach(function (select) {
      updateSelectOptions(
        select,
        product,
        selectedOptions,
        colorIndex,
        weightIndex,
        weightIndex,
        'data-kk-uniikki-weight-hidden'
      );
    });

    updateRadioOptions(
      container,
      product,
      selectedOptions,
      colorIndex,
      weightIndex,
      weightIndex,
      'data-kk-uniikki-weight-hidden'
    );
  }

  function formatMoney(cents, sectionData) {
    var moneyFormat = sectionData && sectionData.settings && sectionData.settings.money_format;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function setLowestPriceVisibility(root, visible) {
    root.hidden = !visible;
    root.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function updateLowestPrice(root, variant) {
    var compareAtPrice = Number(variant && variant.compare_at_price);
    var price = Number(variant && variant.price);

    if (!variant || !(compareAtPrice > price)) {
      setLowestPriceVisibility(root, false);
      return;
    }

    var value = root.querySelector('[data-lowest-30d-price-value]');

    if (value) {
      value.textContent = formatMoney(compareAtPrice, getSectionData(getSectionId(root)));
    }

    setLowestPriceVisibility(root, true);
  }

  function keepBackInStockTriggerClean(root) {
    var trigger = root.querySelector('.kk-bis-trigger-anchor');
    var triggerLabel = root.getAttribute('data-trigger-label') || '';

    if (trigger && trigger.getAttribute('aria-label') !== triggerLabel) {
      trigger.setAttribute('aria-label', triggerLabel);
    }
  }

  function initializeBackInStockRoot(root) {
    if (initializedBackInStockRoots.has(root)) {
      return;
    }

    initializedBackInStockRoots.add(root);
    keepBackInStockTriggerClean(root);

    var trigger = root.querySelector('.kk-bis-trigger-anchor');

    if (trigger && window.MutationObserver) {
      new MutationObserver(function () {
        keepBackInStockTriggerClean(root);
      }).observe(trigger, {
        attributes: true,
        attributeFilter: ['aria-label']
      });
    }
  }

  function updateBackInStock(root, variant) {
    root.hidden = !variant || variant.available !== false;
    root.setAttribute('aria-hidden', root.hidden ? 'true' : 'false');
  }

  function updateFeatureRoot(root, variant) {
    var product = getProductData(root);
    var resolvedVariant = findVariant(product, variant) || getCurrentVariant(root, product, false);

    if (root.matches(LOWEST_PRICE_SELECTOR)) {
      updateLowestPrice(root, resolvedVariant);
    } else if (root.matches(BACK_IN_STOCK_SELECTOR)) {
      initializeBackInStockRoot(root);
      updateBackInStock(root, resolvedVariant);
    }
  }

  function updateAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    toArray(root.querySelectorAll(PRODUCT_OPTION_SELECTOR)).forEach(function (container) {
      var product = getProductData(container);
      var variant = getCurrentVariant(container, product, false);

      if (variant) {
        syncOptionControls(container, variant, product);
      }

      updateUniikkiContainer(container);
    });

    toArray(root.querySelectorAll(LOWEST_PRICE_SELECTOR + ', ' + BACK_IN_STOCK_SELECTOR)).forEach(function (featureRoot) {
      updateFeatureRoot(featureRoot, null);
    });
  }

  function scheduleUpdateAll() {
    if (updateFrame !== null) {
      return;
    }

    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateAll(document);
    });
  }

  function eventMatchesRoot(event, root) {
    var eventProduct = event && event.detail && event.detail.product;
    return !eventProduct || !eventProduct.id || String(eventProduct.id) === String(root.getAttribute('data-product-id'));
  }

  function handleVariantSwitch(event) {
    var eventProduct = event.detail && event.detail.product;
    var variant = event.detail && event.detail.variant;

    toArray(document.querySelectorAll(PRODUCT_OPTION_SELECTOR)).forEach(function (container) {
      var product = getProductData(container);

      if (!product || (eventProduct && eventProduct.id && String(product.id) !== String(eventProduct.id))) {
        return;
      }

      var resolvedVariant = findVariant(product, variant);

      if (resolvedVariant) {
        syncOptionControls(container, resolvedVariant, product);
        updateUniikkiContainer(container);
      }
    });

    toArray(document.querySelectorAll(LOWEST_PRICE_SELECTOR + ', ' + BACK_IN_STOCK_SELECTOR)).forEach(function (root) {
      if (eventMatchesRoot(event, root)) {
        updateFeatureRoot(root, variant);
      }
    });
  }

  function handleDocumentClick(event) {
    var button = event.target.closest && event.target.closest('[data-variant-load-more-button]');

    if (button) {
      expandOptionList(button);
    }
  }

  function isAvailableFocusTarget(element) {
    if (!element || !element.isConnected || element.disabled || element.getClientRects().length === 0) {
      return false;
    }

    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) {
      return false;
    }

    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function rememberPhotoswipeReturnFocus(event) {
    var target = event.target;
    var viewer = target && target.closest
      ? target.closest('[data-gallery-viewer]')
      : null;

    if (!viewer) {
      return;
    }

    var selectedFigure = viewer.querySelector('[data-gallery-figure][data-gallery-selected="true"]');
    var zoomButton = viewer.querySelector('[data-gallery-expand]');

    if (
      !selectedFigure ||
      selectedFigure.getAttribute('data-media-type') !== 'image' ||
      !isAvailableFocusTarget(zoomButton)
    ) {
      return;
    }

    var section = viewer.closest('.shopify-section[id]');
    photoswipeReturnFocusTarget = zoomButton;
    photoswipeReturnFigureTarget = selectedFigure;
    photoswipeReturnSectionId = section ? section.id : '';
  }

  function resolvePhotoswipeReturnFocusTarget() {
    if (isAvailableFocusTarget(photoswipeReturnFocusTarget)) {
      return photoswipeReturnFocusTarget;
    }

    if (photoswipeReturnSectionId) {
      var section = document.getElementById(photoswipeReturnSectionId);
      var replacement = section && section.querySelector('[data-gallery-viewer] [data-gallery-expand]');

      if (isAvailableFocusTarget(replacement)) {
        return replacement;
      }
    }

    if (isAvailableFocusTarget(photoswipeReturnFigureTarget)) {
      return photoswipeReturnFigureTarget;
    }

    return null;
  }

  function restorePhotoswipeReturnFocus(dialog) {
    var target = resolvePhotoswipeReturnFocusTarget();
    var active = document.activeElement;
    var activeIsLost = !active || active === document.body || active === document.documentElement || !active.isConnected;
    var activeIsGalleryControl = Boolean(active && active.closest && active.closest('[data-gallery-figure], [data-gallery-thumbnail]'));
    var activeIsDialog = Boolean(active && dialog.contains(active));

    if (!target || active === target || (!activeIsLost && !activeIsGalleryControl && !activeIsDialog)) {
      photoswipeReturnFocusTarget = null;
      photoswipeReturnFigureTarget = null;
      photoswipeReturnSectionId = '';
      return;
    }

    window.requestAnimationFrame(function () {
      if (dialog.getAttribute('aria-hidden') !== 'true') {
        return;
      }

      photoswipeReturnFocusTarget = null;
      photoswipeReturnFigureTarget = null;
      photoswipeReturnSectionId = '';

      if (!isAvailableFocusTarget(target)) {
        return;
      }

      try {
        target.focus({ preventScroll: true });
      } catch (error) {
        target.focus();
      }
    });
  }

  function observePhotoswipeFocusReturn() {
    var dialog = document.querySelector('[data-photoswipe]');

    if (!dialog || !window.MutationObserver || dialog.hasAttribute('data-kk-focus-return-ready')) {
      return;
    }

    dialog.setAttribute('data-kk-focus-return-ready', 'true');
    photoswipeWasOpen = dialog.getAttribute('aria-hidden') === 'false';

    new MutationObserver(function () {
      var isOpen = dialog.getAttribute('aria-hidden') === 'false';

      if (isOpen) {
        photoswipeWasOpen = true;
        return;
      }

      if (!photoswipeWasOpen) {
        return;
      }

      photoswipeWasOpen = false;
      restorePhotoswipeReturnFocus(dialog);
    }).observe(dialog, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  function handleDocumentChange(event) {
    var target = event.target;

    if (!target || target.nodeType !== 1) {
      return;
    }

    if (
      target.matches('[name="id"], [data-variants], [data-product-option]') ||
      target.closest(PRODUCT_OPTION_SELECTOR)
    ) {
      scheduleUpdateAll();
    }
  }

  function handleSectionLoad(event) {
    sectionDataCache = Object.create(null);
    updateAll(event.target || document);
  }

  function observeDynamicContent() {
    if (!window.MutationObserver || !document.body) {
      return;
    }

    new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return toArray(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches(PRODUCT_OPTION_SELECTOR + ', ' + LOWEST_PRICE_SELECTOR + ', ' + BACK_IN_STOCK_SELECTOR) ||
            node.querySelector(PRODUCT_OPTION_SELECTOR + ', ' + LOWEST_PRICE_SELECTOR + ', ' + BACK_IN_STOCK_SELECTOR)
          );
        });
      });

      if (shouldUpdate) {
        scheduleUpdateAll();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function initialize() {
    updateAll(document);
    observeDynamicContent();
    observePhotoswipeFocusReturn();
  }

  document.addEventListener('click', rememberPhotoswipeReturnFocus, true);
  document.addEventListener('click', handleDocumentClick);
  document.addEventListener('change', handleOptionChangeCapture, true);
  document.addEventListener('change', handleDocumentChange);
  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('variant:change', handleVariantSwitch);
  document.addEventListener('product:variant-change', handleVariantSwitch);
  window.addEventListener('shopify-variants:switch-variant', handleVariantSwitch);
  window.addEventListener('variant:change', handleVariantSwitch);
  window.addEventListener('product:variant-change', handleVariantSwitch);
  window.addEventListener('pageshow', scheduleUpdateAll);
  window.addEventListener('popstate', scheduleUpdateAll);

  window.KKProductVariantController = {
    refresh: scheduleUpdateAll,
    version: '1.0.0'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
